import React, { useEffect, useRef, useState } from 'react'

import Layout from 'components/Layout'
import SidebarCommunityAccordian from 'components/Sidebars/SidebarCommunityAccordian'
import EmptyLogo from 'images/SiteRise.png'

const ChainXy_Catalogue = () => {
	return (
		<Layout>
			<Layout.Page>
				<Layout.Body>
					<div>
						<div>
							<img src={EmptyLogo} alt="" />
						</div>
					</div>
				</Layout.Body>
			</Layout.Page>
		</Layout>
	)
}

export default ChainXy_Catalogue
